define([], ()=> {
    return {
        /**
         * returns the stage for the current hostname
         *
         * @param represents location.hostname
         * @returns {string} one of the following stages ('test', 'int', 'acc', 'prod')
         * @returns undefined if hostname does not include baloise.ch
         */
        getStage: (hostname) => {
            const getMagnoliaStage = (hostname) => {
                const subdomain = hostname.substring(0, hostname.indexOf('.'));
                return subdomain.includes('-www') ? subdomain.substring(0, hostname.indexOf('-')) : subdomain;
            }

            if (hostname.includes('baloise.ch')) {
                return ['baloise', 'www'].includes(getMagnoliaStage(hostname))
                    ? 'prod'
                    : getMagnoliaStage(hostname);
            }
            return;
        },
    };
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/util/UrlUtil.js